import { render, staticRenderFns } from "./CategoriesComponent.vue?vue&type=template&id=68f7e144"
import script from "./CategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoriesComponent.vue?vue&type=style&index=0&id=68f7e144&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports